import { firstValueFrom, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Constants } from "@constants";
import { ClienteDTO, ClientePedidoPermisoTemplateDTO, ClientePermisoTemplateDTO, IClienteDTO } from "@DTOS";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { Nilable } from "@shared/utils";

@Injectable({
    providedIn: "root"
})
export class ClientesServiceBackend {
    constructor(protected http: HttpClient) {}

    public async getClientes(): Promise<ClienteDTO[]> {
        return await firstValueFrom(
            this.http.get<IClienteDTO[]>(`${Constants.apiURL}/customers`).pipe(
                map(response => response.map(cliente => new ClienteDTO(cliente)))
            )
        ) ?? [];
    }

    public async getCliente(id: number): Promise<ClienteDTO> {
        const response = await firstValueFrom(this.http.get<IClienteDTO>(`${Constants.apiURL}/customers/${id}`));

        return new ClienteDTO(response);
    }

    public async postCliente(clienteDTO: ClienteDTO): Promise<Nilable<ClienteDTO>> {
        return await firstValueFrom(
            this.http.post<IClienteDTO>(
                `${Constants.apiURL}/customers`, clienteDTO.toJSON()
            ).pipe(
                map(response => new ClienteDTO(response)),
                catchError(() => of(null))
            )
        );
    }

    public async patchCliente(clienteDTO: ClienteDTO): Promise<Nilable<ClienteDTO>> {
        return await firstValueFrom(
            this.http.patch<IClienteDTO>(
                `${Constants.apiURL}/customers/${clienteDTO.id}`, clienteDTO.toJSON()
            ).pipe(
                map(response => new ClienteDTO(response)),
                catchError(() => of(null))
            )
        );
    }

    public async deleteCliente(clienteDTO: ClienteDTO): Promise<boolean> {
        return await firstValueFrom(
            this.http.delete<boolean>(`${Constants.apiURL}/customers/${clienteDTO.id}`)
                .pipe(
                    catchError(() => of(false)),
                    mergeMap(() => of(true))
                )
        );
    }

    public getClienteTemplates(id: number): Observable<ClientePermisoTemplateDTO[]> {
        return this.http.get<ClientePermisoTemplateDTO[]>(`${Constants.apiURL}/customers/${id}/templates`);
    }

    public postClienteTemplate(
        id: number, pedidoPermisoDTO: ClientePedidoPermisoTemplateDTO
    ): Observable<void> {
        return this.http.post<void>(
            `${Constants.apiURL}/customers/${id}/templates`, pedidoPermisoDTO.toJSON()
        );
    }

    public deleteClienteTemplate(
        id: number, idPermisoDTO: number
    ): Observable<void> {
        return this.http.delete<void>(`${Constants.apiURL}/customers/${id}/templates/${idPermisoDTO}`);
    }
}
